export const fetchSwiper = () =>
    import(
        'swiper/core'
        /* webpackChunkName: "swiper" */
    );
